import { render, staticRenderFns } from "./AccountForm.vue?vue&type=template&id=22fdb874&scoped=true"
import script from "./AccountForm.vue?vue&type=script&lang=js"
export * from "./AccountForm.vue?vue&type=script&lang=js"
import style0 from "./AccountForm.vue?vue&type=style&index=0&id=22fdb874&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fdb874",
  null
  
)

export default component.exports